import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { getTrackNextActions } from "../api";

export const useTrackNextActionsQuery = () => {
  const { trackId } = useParams<{ trackId: string }>();

  const query = useQuery({
    queryKey: ["track-next-actions"],
    queryFn: () => getTrackNextActions(trackId || ""),
    enabled: !!trackId,
  });

  return {
    ...query,
    data: query.data?.data,
  };
};
